'use strict';
import axios from 'axios';
import getHeader from '../config/header';
import Addresses from '../controllers/addresses.controller';

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api";

const Listings = {

    async getAll() {
        try {
            const header = await getHeader()

            let response = await axios.get(API_URL + '/listings', header);

			return response.data;

		} catch(error) {
            return false;
		}
    },

    async getTotalCount() {
        try {
            const header = await getHeader()

            let response = await axios.get(API_URL + '/listing/countAll', header);

			return response.data.count;

		} catch(error) {
            return false;
		}
    },

    async getByID(listingID) {
        try {
            if (!listingID) {
                return { error: 'No artwork ID provided' };
            }
            const header = await getHeader();

            let response = await axios.get(API_URL + '/listing/' + listingID, header);

            return response.data;

        } catch(error) {
            return false;
        }

    },

    async verify(listingID) {
        try {
            if (!listingID) {
                return { error: 'No artwork ID provided' };
            }
            const header = await getHeader();

            let response = await axios.post(API_URL + '/listing/verify/' + listingID, {
                    "verified": true
                }, header);

            if (response.data.verified == 1) {
                return true;
            }

        } catch(error) {
            return false;
        }
    },

    async unverify(listingID) {
        try {
            if (!listingID) {
                return { error: 'No artwork ID provided' };
            }
            const header = await getHeader();

            let response = await axios.post(API_URL + '/listing/verify/' + listingID, {
                    "verified": false
                }, header);
            
            if (response.data.verified == 0) {
                return true;
            }

        } catch(error) {
            return false;
        }
    },
    async status(listingID) {
        try {
            if (!listingID) {
                return { error: 'No artwork ID provided' };
            }
            const header = await getHeader();

            let response = await axios.post(API_URL + '/listing/archive-unarchive/' + listingID, {
                    
                }, header);
            
            if (response.data.is_archived == 0 || response.data.is_archived == 1) {
                return true;
            }

        } catch(error) {
            return false;
        }
    },

    async approve(listingID) {
        try {
            if (!listingID) {
                return { error: 'No artwork ID provided' };
            }
            const header = await getHeader();

            let response = await axios.post(API_URL + '/listing/approve/' + listingID, {
                "approved": true
            }, header);
            
            if (response.data.approved == 1) {
                return true;
            }

        } catch(error) {
            return false;
        }
    },

    async unapprove(listingID) {
        try {
            if (!listingID) {
                return { error: 'No artwork ID provided' };
            }
            const header = await getHeader();

            let response = await axios.post(API_URL + '/listing/approve/' + listingID, {
                    "approved": false
                }, header);
            
            if (response.data.approved == 0) {
                return true;
            } else {
                return false;
            }

        } catch(error) {
            return false;
        }
    },

    async getUnapproved(museumID = null) {
        try {
            const header = await getHeader();

            let response;
            if (museumID === null) {
                response = await axios.get(API_URL + '/listings?unapproved=true', header);
            } else {
                response = await axios.get(API_URL + '/listings?unapproved=true&museumId=' + museumID, header);
            }
            
            return !response.data ? false : response.data;

        } catch(error) {
            return false;
        }
    },

    async getUnapprovedCount(museumID = null) {
        try {
            const header = await getHeader();
            let response;

            if (museumID == null) {
                response = await axios.get(API_URL + '/listing/countUnapproved', header);
            } else {
                response = await axios.get(API_URL + '/listing/countUnapproved?museumId=' + museumID, header);
            }

            return response.data.count;

        } catch(error) {
            return false;
        }
    },

    async getUnverifiedCount(museumID = null) {
        try {
            const header = await getHeader();
            let response;

            if (museumID === null) {
                response = await axios.get(API_URL + '/listing/countUnverified', header);
            } else {
                response = await axios.get(API_URL + '/listing/countUnverified' + '/?museumId=' + museumID, header);
            }

            return response.data.count;

        } catch(error) {
            return false;
        }
    },

    async search(era, category, artist, museum, medium, withRelations) {
		try {
            if (!era && !category && !artist && !museum && !medium) {
                return { error: 'At least one search criteria must be provided when searching for listings' };
            }
    
            if (withRelations == null) {
                withRelations = false;
            }

            const header = await getHeader();
            
            let response = await axios.post(API_URL + '/searchListings', {
                    "eraId": era,
                    "category": category,
                    "artistId": artist,
                    "museumId": museum,
                    "mediumId": medium,
                    "withRelations": withRelations
                }, header);

			return response.data;

		} catch(error) {
            return false;
		}
    },
    
    async getByMuseumID(museumID) {
		try {
            if (!museumID) {
                return { error: 'A valid museum ID is required' };
            }

            const header = await getHeader();

            let response = await axios.get(API_URL + '/listings?museumId=' + museumID, header);

			return response.data;

		} catch(error) {
            return false;
		}
    },

    async getPublicArt() {
        try {
            const header = await getHeader();

            let response = await axios.get(API_URL + '/listings', header);

            let publicArtworks = [];

            for (let publicArt of response.data) {
                if (publicArt.museum === null) {
                    publicArtworks.push(publicArt);
                }
            }

			return publicArtworks;

		} catch(error) {
            return false;
		}
    },
    

    async countForMuseum(museumID) {
		try {
            if (!museumID) {
                return { error: 'A valid museum ID is required' };
            }

            const header = await getHeader();

            let response = await axios.get(API_URL + '/listings?museumId=' + museumID, header);
            
			return response.data.length;

		} catch(error) {
            return false;
		}
    },

    async catalogNew(listing) {
        try {
            if (!listing.name || !listing.year || !listing.medium || !listing.artist) {
                return { error: 'A mandatory field is missing' };
            }

            if (isNaN(listing.year)) {
                return { error: 'The artwork year must be a number' };
            }

            const header = await getHeader();

            let response = await axios.post(API_URL + '/listing', {
                    "name": listing.name,
                    "eraId": !listing.era ? null : listing.era.id,
                    "category": listing.category,
                    "objectNumber": listing.objectNumber,
                    "year": listing.year,
                    "description": listing.description,
                    "artistId": listing.artist,
                    "museumId": listing.museum.id,
                    "mediumId": listing.medium.id,
                    "circa": listing.circa,
                    "bc": listing.BC,
                    "onDisplay": listing.onDisplay,
                }, header);
            
            if (response.data) {
                return true;
            }

        } catch(error) {
            return false;
        }
    },

    async updateExisting(listing) {
        try {
            // If the museum is missing then we're dealing with public art
            // and public art has no mandatory fields
            if (listing.museum != null) {
                if (!listing.id || !listing.name || !listing.medium_id) {
                    return { error: 'A mandatory field is missing' };
                }

                if (listing.year !== null && isNaN(listing.year)) {
                    return { error: 'The artwork year must be a number' };
                }
            } else {
                if (!listing.address_id) {
                    return { error: 'The addressID is missing' };
                }
            }

            const header = await getHeader();

            let response = await axios.patch(API_URL + '/listing/' + listing.id, {
                    "name": !listing.name ? null : listing.name,
                    "eraId": !listing.era_id ? null : listing.era_id,
                    "category": !listing.category ? null : listing.category,
                    "objectNumber": !listing.object_number ? null : listing.object_number,
                    "year": !listing.year ? null : listing.year,
                    "description": !listing.description ? null : listing.description,
                    "artistId": !listing.artist_id ? null : listing.artist_id,
                    "museumId": !listing.museum_id ? null : listing.museum_id,
                    "mediumId": !listing.medium_id ? null : listing.medium_id,
                    "addressId": !listing.address_id ? null : listing.address_id,
                    "verified": true,
                    "circa": !listing.circa ? !!+listing.circa : !!+listing.circa,
                    "bc": !listing.BC ? !!+listing.BC : !!+listing.BC,
                    "onDisplay": listing.on_display === true || listing.on_display === '1' ? !!+listing.on_display : !!+listing.on_display
                }, header);
            
            if (!response.data.id) {
                return false;
            }

            return true;

        } catch(error) {
            return false;
        }
    },

    async uploadImage(listingID, filename, content) {
        try {
            if (!listingID || !filename || !content) {
                return { error: 'A mandatory field is missing' };
            }

            const header = await getHeader();

            let response = await axios.post(API_URL + '/listing/upload/' + listingID, {
                    "fileName": filename,
                    "content": content
                }, header);
            
            if (response.data) {
                return true;
            }

        } catch(error) {
            return false;
        }
    },

    async delete(listingID) {
        try {
            if (!listingID) {
                return { error: 'Artwork ID missing' };
            }

            const header = await getHeader();
            
            let response = await axios.delete(API_URL + '/listing/' + listingID, header);

            return response.data.message.includes('Successfully deleted the listing');

        } catch(error) {
            return false;
        }
    },


    async getByArtist(artistID) {
        try {
            if (!artistID) {
                return { error: 'ArtistID is missing' }
            }

            const header = await getHeader();
            
            let response = await axios.get(API_URL + '/listings?artistId=' + artistID, header);

			return response.data;

		} catch(error) {
            return false;
		}
    }
    
}

export default Listings;